module.exports = __webpack_public_path__ + "source-code-pro-v11-latin-regular.woff?17ea4760cdf09ade45a20bce5f2933a9";